module.exports = __webpack_public_path__ + "static/media/defaultstate-credentials.144ca60d.gif";